<template>
    <div>
        <v-container fluid class="grey-container cta-container" :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + require('@/assets/environment-banner.png') + ')' }">
<!--            <v-row>-->

<!--                <v-col md="12" class="align-center" style="padding: 0">-->
<!--                    <div-->
<!--                            :style="{'background-image': 'url(' + require('@/assets/environment-banner.png') + ')', 'min-height': '500px', 'background-size': 'cover'}"-->
<!--                    >-->
<!--                        <v-img-->
<!--                                :src="require('@/assets/fmk-environment-logo.png')"-->
<!--                                class="cta-card-img"-->
<!--                                max-width="50%"-->
<!--                                :style="{'margin': 'auto auto'}"-->
<!--                        ></v-img>-->
<!--                    </div>-->

<!--                </v-col>-->
<!--            </v-row>-->
            <v-container class="contain-width">
                <v-row>
                    <v-col
                            cols="12"
                    >
                        <h1 v-if="brand === 'findmykit'" class="mb-sm-12"><span class="d-sr-only">{{ $t('headings.{brand} and the environment', {brand: brandName}) }}</span><v-img
                                :src="require('@/assets/fmk-environment-logo.png')"
                                max-width="60%"
                                :style="{'margin': 'auto'}"
                        ></v-img></h1>
                        <h1 v-else class="md-display-2 black--text mb-sm-12">
                          <span>{{ $t('headings.{brand} and the environment', {brand: brandName}) }}</span>
                        </h1>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                            cols="12"
                    >
                        <v-card
                                class="mx-auto product-card mt-xs-3 mt-sm-6 mt-md-16"
                                outlined
                        >

                            <v-card-text>
                                <p class="text-h6">{{ $t('With more than 3000 items lost per person during a lifetime and around 10 minutes a day spent searching for lost property, {brand} is a solution that circumvents the requirement to replace lost possessions. Whilst the financial aspect is one of our priorities when it comes to having to buy replacement items, so too is the cost on the environment.', {brand: brandName})}}</p>
                                <p class="text-h5 primary--text">{{ $t("Here at {brand}, we've created a product that helps to solve a universal problem whilst reducing the environmental impact.", {brand: brandName}) }}</p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                        cols="12"
                        sm="12"
                        md="4"
                    >
                        <v-card class="product-card equal-height-card">

                            <div class="d-flex flex-no-wrap justify-space-between">
                                <v-card-title class="headline primary--text">{{ $t("The facts") }}</v-card-title>
                                <v-icon :light="isLight" size="100px" class="mt-1">mdi-text-box-check-outline</v-icon>
                            </div>

                            <v-card-text>
                                <p class="text-subtitle-1 font-weight-bold">{{ $t("Did you know that clothing items are amongst the top ten items most commonly lost in both adults and children?") }}</p>
                                <p class="text-body-1">{{ $t("When you then consider how detrimental the fashion industry can be on the environment, any way we can help lessen this would undoubtedly be beneficial. This industry contributes towards the production of greenhouse gases, uses up trillions of litres of water (1.5 trillion each year to be precise) and energy too. Helping you to keep track of all your items with the {brand} system – clothing or otherwise – can reduce the need to buy new items, thus putting less demand on the fashion industry.", {brand: brandName}) }}</p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="12"
                        md="4">
                        <v-card class="product-card equal-height-card">
                            <div class="d-flex flex-no-wrap justify-space-between">
                                <v-card-title class="headline primary--text">{{ $t("The products") }}</v-card-title>
                                <v-avatar
                                        class="mt-3 mr-3"
                                        size="80"
                                        tile
                                >
                                <v-img
                                        :src="bioIcon"
                                        width="150px"
                                ></v-img>

                                </v-avatar>
                            </div>
                            <v-card-text>
                                <p class="text-subtitle-1 font-weight-bold">{{ $t("We use PPG Teslin® Biodegradable Substrate here at {brand}* - a durable synthetic paper with some serious green credentials! All the quality, longevity, ease of use, heat stability, performance and security you’d expect from one of our products… whilst remaining environmentally-responsible at all times.", {brand: brandName}) }}</p>
                                <p class="text-body-1">{{ $t("This Teslin substrate is designed to biodegrade when you need it to, breaking down under anaerobic conditions (lack of oxygen) with microorganisms that can digest such polymers into materials such as carbon dioxide and water. In fact, it's been shown that this material degrades by 7.8% over a period of 74 days with continual degradation as time goes on. All PPG Teslin® Biodegradable Substrate products have been independently tested to ASTM standard D5511 too, giving you total peace of mind when it comes to purchasing {brand} products.", {brand: brandName}) }}
                                    </p>
                                <p class="text-caption">*{{ $t("Our iron-on and sticker products are not made of the same material.") }}</p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col
                            cols="12"
                            sm="12"
                            md="4">
                        <v-card class="product-card equal-height-card">
                            <div class="d-flex flex-no-wrap justify-space-between">
                                <v-card-title class="headline primary--text">{{ $t("The technology") }}</v-card-title>
                                <v-icon :light="isLight" size="80px" class="mt-4 mr-3">mdi-qrcode-scan</v-icon>
                            </div>
                            <v-card-text>
                                <p class="text-subtitle-1 font-weight-bold">{{ $t("When you label your possessions with a {brand} tag, you can be confident that they’re protected should they ever get lost.", {brand: brandName}) }}</p>
                                <p class="text-body-1">{{ $t("If found, they can then be scanned by a member of our network and the owner alerted via an email or text message. This negates a new item having to be purchased as a replacement – simple! So next time you think of {brand}, remember that being in the pink (just like our logo!) may be greener than you realise.", {brand: brandName}) }}</p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-card class="product-card">
                            <v-card-text>
                                <vimeo-player ref="player" :video-id="videoID" @ready="onReady" class="player-container" :options="options">
                                </vimeo-player>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>
    import Footer from './Footer'
    import {i18n} from "../i18n";
    import {mapState} from "vuex";

    export default {
        name: "Environment",
        metaInfo () {
            return {
                title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Environment'),
                htmlAttrs: {
                    lang: i18n.locale
                },
                meta: [
                    { name: 'description', content: i18n.t("Here at {brand}, we've created a product that helps to solve a universal problem whilst reducing the environmental impact", {brand: this.brandName}) + '.' }
                ]
            }
        },
        components: {
            'Footer': Footer
        },
        data () {
            return {
                videoID: '410322496',
                options: {'responsive': true, 'dnt': true},
                playerReady: false
            }
        },
        mounted () {
            document.getElementById("scrolling-content").scrollTop = 0

            window.prerenderReady = true;
        },
        methods: {
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            onReady() {
                this.playerReady = true
            },
            play() {
                this.$refs.player.play()
            },
            stop() {
                this.$refs.player.stop()
            }
        },
        computed: {
          ...mapState({
            brand: state => state.brand,
            brandName: state => state.brandName
          }),
          isLight() {
            return Boolean(this.brand !== 'neotag')
          },
          bioIcon() {
            if (this.brand === 'neotag') {
              return require('@/assets/bio-icon-dark.png')
            }
            return require('@/assets/bio-icon.png')
          }
        }
    }
</script>

<style scoped>
    .product-card {
        border-radius: 15px;
        border: none !important;
    }
    .equal-height-card {
        height: 100%;
    }
    .player-container {
        width: 100% !important;
    }
</style>
